/**
 * Custom: blokerer "Til kassen", indtil handelsbetingelserne er accepteret
 * (se snippets/cart-terms.liquid). Valget huskes, når temaet genindlæser kurven.
 */
(() => {
  const STORAGE_KEY = 'cartTermsAccepted';

  const remember = (value) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, value ? '1' : '');
    } catch (e) {}
  };

  const isRemembered = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const restore = () => {
    if (!isRemembered()) return;
    document.querySelectorAll('[data-cart-terms-checkbox]').forEach((box) => {
      box.checked = true;
    });
  };

  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-cart-terms-checkbox]');
    if (!box) return;
    remember(box.checked);
    const error = box.closest('[data-cart-terms]').querySelector('[data-cart-terms-error]');
    if (box.checked && error) error.textContent = '';
  });

  // Fang klik på "Til kassen" før temaet sender formularen
  document.addEventListener(
    'click',
    (e) => {
      const checkoutBtn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (!checkoutBtn) return;

      const terms = document.querySelector('[data-cart-terms]');
      if (!terms) return;

      const box = terms.querySelector('[data-cart-terms-checkbox]');
      if (box && box.checked) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const error = terms.querySelector('[data-cart-terms-error]');
      if (error) error.textContent = error.dataset.message;
      terms.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  // Gendan fluebenet når temaet har genindlæst kurven
  let queued = false;
  const queueRestore = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      restore();
    });
  };

  restore();
  new MutationObserver(queueRestore).observe(document.documentElement, { childList: true, subtree: true });
})();
